"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5203],{

/***/ 25203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_SocialProofContainer; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/icons/green_customer.tsx



const GreenCustomerIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "70",
  viewBox: "0 0 70 70",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-275 -3441) translate(275 3441)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "35",
        cy: "35",
        r: "35",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M25.977 28.71c6.113 0 11.074-4.96 11.074-11.073 0-6.114-4.96-11.075-11.074-11.075s-11.075 4.96-11.075 11.075c0 6.114 4.96 11.074 11.075 11.074zm0-3.69c-4.069 0-7.383-3.315-7.383-7.383 0-4.069 3.314-7.383 7.383-7.383 4.068 0 7.382 3.314 7.382 7.383 0 4.068-3.314 7.382-7.382 7.382zm13.535 20.917c2.038 0 3.691-1.653 3.691-3.691v-1.969c0-5.706-4.63-10.336-10.336-10.336-2.207 0-3.268 1.23-6.89 1.23-3.623 0-4.676-1.23-6.891-1.23-5.706 0-10.336 4.63-10.336 10.336v1.969c0 2.038 1.653 3.691 3.691 3.691h27.07zm0-3.691h-27.07v-1.969c0-3.66 2.983-6.644 6.644-6.644 1.123 0 2.945 1.23 6.89 1.23 3.976 0 5.76-1.23 6.891-1.23 3.66 0 6.645 2.984 6.645 6.644v1.969z",
          transform: "translate(8.75 8.75)"
        })
      })]
    })
  })
});

/* harmony default export */ var green_customer = (GreenCustomerIcon);
// EXTERNAL MODULE: ./src/icons/green_car.tsx
var green_car = __webpack_require__(22339);
;// CONCATENATED MODULE: ./src/icons/green_brand.tsx



const GreenBrandIcon = () => /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "70",
  viewBox: "0 0 70 70",
  children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      transform: "translate(-565 -3441) translate(565 3441)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "35",
        cy: "35",
        r: "35",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M26.806 26.25c.5.007 1.019-.164 1.45-.608l6.746-6.973c2.058-2.126 2.489-6.16-.41-8.634-2.625-2.242-6.09-1.217-7.786.533-1.695-1.75-5.16-2.775-7.78-.533-2.898 2.475-2.467 6.508-.41 8.634l6.741 6.973c.43.444.943.608 1.45.608zm0-3.794l-5.886-6.09c-.895-.917-1.107-2.715.178-3.815.964-.82 2.468-.615 3.37.321l2.338 2.413 2.331-2.42c.903-.936 2.413-1.141 3.37-.321 1.292 1.1 1.074 2.898.185 3.821l-5.886 6.091zm-14.219 21.3c.602 0 1.094-.491 1.094-1.093 0-.513-.177-1.012-.492-1.408l-4.02-5.025c-.622-.772-.957-1.736-.957-2.734v-13.2c0-.793.534-1.524 1.313-1.668 1.046-.205 1.969.595 1.969 1.606v.595l.001.242.002.917.001.358.002.776.004 2.14.002.87.005 1.985.002.65.001.532c0 .52.192 1.012.533 1.408l5.23 6.33c1.21 1.463 3.568-.225 2.317-1.928l-3.383-4.58c-.554-.717-.417-1.75.3-2.303.739-.575 1.764-.397 2.304.3l4.901 6.371c.588.766.91 1.703.91 2.666v5.093c0 .602.492 1.094 1.093 1.094h2.188c.601 0 1.094-.492 1.094-1.094V37.57c0-.964.32-1.9.909-2.666l4.901-6.37c.54-.698 1.565-.869 2.304-.302.718.554.854 1.58.3 2.304l-3.383 4.58c-1.258 1.702 1.107 3.39 2.317 1.928l5.23-6.33c.341-.397.526-.889.533-1.408v-4.042-.438l.001-1.292v-.412l.003-1.134v-.334l.002-1.03v-.39c0-1.011.917-1.811 1.97-1.606.779.15 1.312.875 1.312 1.668v13.2c0 .991-.335 1.955-.957 2.728L40.43 41.24c-.321.404-.492.896-.492 1.408 0 .602.492 1.094 1.094 1.094h1.114c.335 0 .65-.15.855-.417l4.012-5.058c1.08-1.354 1.675-3.05 1.675-4.786V20.405c-.007-2.618-1.976-4.908-4.594-5.079-2.864-.191-5.257 2.085-5.257 4.908v.329l-.002.617v.263l-.002.598-.01 3.389c-2.036-1.354-4.955-1.06-6.616 1.093l-4.909 6.378c-.184.24-.341.506-.492.766-.157-.26-.307-.526-.492-.766l-4.908-6.378c-1.682-2.18-4.608-2.426-6.617-1.093l-.008-3.062-.002-.64v-.287l-.002-.499v-.206l-.002-.502c0-2.823-2.393-5.1-5.257-4.908-2.618.171-4.587 2.461-4.587 5.08v13.09c0 1.73.595 3.432 1.675 4.785l4.013 5.059c.205.26.526.417.854.417h1.114z",
          transform: "translate(8.75 8.75)"
        })
      })]
    })
  })
});

/* harmony default export */ var green_brand = (GreenBrandIcon);
;// CONCATENATED MODULE: ./src/containers/data/SocialProofData.tsx


const SocialProofData = [{
  title: '700.000 Clienti',
  description: 'soddisfatti',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_customer, {})
}, {
  title: '35.000 Auto',
  description: 'acquistate',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_car/* default */.Z, {})
}, {
  title: '27 Brand',
  description: 'con cui collaboriamo',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(green_brand, {})
}];
/* harmony default export */ var data_SocialProofData = (SocialProofData);
;// CONCATENATED MODULE: ./src/containers/SocialProofContainer.tsx




const SocialProofList = dynamic_default()(() => __webpack_require__.e(/* import() */ 8292).then(__webpack_require__.bind(__webpack_require__, 78292)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(78292)]
  }
});

const SocialProofContainer = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SocialProofList, {
    items: data_SocialProofData,
    title: title
  });
};

/* harmony default export */ var containers_SocialProofContainer = (SocialProofContainer);

/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



const GreenCarIcon = () => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
      transform: "translate(-277 -2666) translate(160 2566) translate(0 100) translate(117)",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#DFF5EB"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
        fill: "#41A476",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M10.468 47.5c1.294 0 2.344-1.05 2.344-2.344v-2.343h34.375v2.343c0 1.294 1.05 2.344 2.344 2.344h1.562c1.294 0 2.344-1.05 2.344-2.344V31.875c0-1.718-.492-3.305-1.3-4.687h1.105c.538 0 1.007-.366 1.137-.887l.586-2.344c.184-.74-.375-1.456-1.138-1.456h-5.099l-3.062-7.605C44.476 11.937 41.607 10 38.42 10H21.58c-3.188 0-6.057 1.937-7.247 4.895L11.27 22.5H6.172c-.762 0-1.322.717-1.136 1.456l.586 2.344c.122.49.632.887 1.136.888h1.105c-.809 1.382-1.3 2.97-1.3 4.686v13.282c0 1.294 1.049 2.344 2.343 2.344h1.562zm33.207-25h-27.35l2.356-5.855c.479-1.189 1.617-1.957 2.899-1.957h16.84c1.282 0 2.42.768 2.898 1.957l2.357 5.854zm3.512 15.625H12.812c-.861 0-1.562-.701-1.562-1.562v-4.688c0-2.585 2.102-4.687 4.687-4.687h28.125c2.585 0 4.688 2.102 4.688 4.687v4.688c0 .86-.701 1.562-1.563 1.562zm-25-3.92c0-1.87-2.812-4.675-4.687-4.675-1.875 0-3.125 1.246-3.125 3.117 0 1.87 1.25 3.116 3.125 3.116s4.687.311 4.687-1.559zM42.5 35.762c1.875 0 3.125-1.246 3.125-3.116s-1.25-3.117-3.125-3.117-4.688 2.805-4.688 4.674c0 1.87 2.813 1.559 4.688 1.559z",
          transform: "translate(10 10)"
        })
      })]
    })
  })
});

/* harmony default export */ __webpack_exports__["Z"] = (GreenCarIcon);

/***/ })

}]);